import { useSyncExternalStore } from 'react';
import { loadShippingDisabled, subscribe } from './store';

/**
 * Reactive read of the per-session "shipping disabled" flag. Defaults to
 * false until the design_system bootstrap resolves and saves the real value.
 */
export function useShippingDisabled(): boolean {
  return useSyncExternalStore(subscribe, loadShippingDisabled, () => false);
}
